import React from "react";
import "./Spinner.scss";

const Spinner = () => {
  return <div className="spinner"></div>;
};

export default Spinner;
